import { useMemo } from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';
import CssBaseline from '@mui/material/CssBaseline';
import { ThemeProvider } from '@mui/material/styles';
import DefaultContext from './component/context/DefaultContext';
import DefaultRouter from './component/layout/DefaultRouter';
import ForbiddenDialog from './component/dialog/ForbiddenDialog';
import AppUpdateBanner from './component/AppUpdateBanner';
import { EnterpriseConfigProvider } from './component/context/EnterpriseConfigContext';
import { useColorMode } from './hooks/useColorMode';
import { buildAppTheme } from './theme/theme';

import {
  RecoilRoot
} from 'recoil';

function App() {

  const queryClient = new QueryClient()
  const { mode } = useColorMode();
  const theme = useMemo(() => buildAppTheme(mode), [mode]);


  return <>
    <div className="App">
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <QueryClientProvider client={queryClient}>
          <EnterpriseConfigProvider>
            <DefaultContext.Provider value={{}}>
              <RecoilRoot>
                <DefaultRouter />
                <ForbiddenDialog />
                <AppUpdateBanner />
              </RecoilRoot>
            </DefaultContext.Provider>
          </EnterpriseConfigProvider>
        </QueryClientProvider>
      </ThemeProvider>
    </div>
  </>




}

export default App;
